import { WHITE_COLOR } from '../../styles/constants';

export const imageBoxStyles = {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  mt: '1rem',
  mb: '1rem',
};

export const profileImageContainer = ImageUrl => ({
  width: '8rem',
  height: '8rem',
  borderRadius: '50%',
  mb: '1rem',
  position: 'relative',
  backgroundImage: `url(${
    ImageUrl ||
    'https://www.prestonvalleydallas.com/wp-content/uploads/2021/12/placeholder.png'
  })`,
  backgroundPosition: 'center',
  backgroundSize: 'cover',
  backgroundRepeat: 'no-repeat',
});

export const imageUploadButton = {
  background: WHITE_COLOR,
  borderRadius: '50%',
  position: 'absolute',
  bottom: 0,
  right: 10,
  '&:hover': {
    background: WHITE_COLOR,
  },
};

export const actionIconsBox = {
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '1rem',
};
